import { BillingInterval, IBusiness } from '@query'

/** Aligned with backend ``ManualInvoicingRequestModel`` field max lengths. */
export const MANUAL_INVOICING_FIELD_MAX = {
  billingAddress: 64,
  postalCodeAndCity: 41,
  additionalInfo: 256
} as const

const formatPostalCodeAndCity = (postalCode?: string, city?: string): string =>
  [postalCode, city].filter(Boolean).join(' ')

export const getManualInvoicingFormDefaults = (business: IBusiness | null | undefined) => {
  const street = business?.invoicing_street || business?.business_street || ''
  const postalCode = business?.invoicing_postal_code || business?.business_postal_code || ''
  const city = business?.invoicing_city || business?.business_city || ''

  return {
    invoicing_method: '' as const,
    email: business?.invoicing_email || business?.owner_email || '',
    billing_address: street,
    postal_code_and_city: formatPostalCodeAndCity(postalCode, city),
    plan: '' as const,
    billing_interval: '' as BillingInterval | '',
    additional_info: ''
  }
}
